import { useState } from "react";
import { Link } from "react-router-dom";
import { FiCheck } from "react-icons/fi";
import MarketingPageLayout from "../../components/marketing/MarketingPageLayout";
import DiwaliOfferOverlay from "../../components/marketing/DiwaliOfferOverlay";
import { PLAN_COMPARISON_ROWS, SSDI_PLANS } from "../../constants/ssdiPlans";
import "../../styles/auth.css";
import "../../styles/marketingPlans.css";
import "../../styles/diwaliOffer.css";

export default function PlansPage() {
  const [selectedId, setSelectedId] = useState("golden");
  const selected = SSDI_PLANS.find((plan) => plan.id === selectedId) || SSDI_PLANS[0];

  const scrollToPlans = () => {
    document.getElementById("pricing-plans")?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <MarketingPageLayout wide>
      <div className="pricing-page--diwali">
        <span className="pricing-rangoli" aria-hidden />
        <span className="pricing-sparkles" aria-hidden>
          <span className="pricing-sparkle" />
          <span className="pricing-sparkle" />
          <span className="pricing-sparkle" />
          <span className="pricing-sparkle" />
          <span className="pricing-sparkle" />
          <span className="pricing-sparkle" />
        </span>

        <header className="marketing-page__hero pricing-hero pricing-hero--diwali">
          <div className="pricing-hero__row">
            <span className="diwali-lamp pricing-hero__diya" aria-hidden>
              <span className="diwali-lamp__flame" />
              <span className="diwali-lamp__bowl" />
            </span>
            <h1 className="marketing-page__title">Plans</h1>
            <span className="pricing-badge pricing-badge--diwali">Diwali Special</span>
            <span className="diwali-lamp pricing-hero__diya" aria-hidden>
              <span className="diwali-lamp__flame" />
              <span className="diwali-lamp__bowl" />
            </span>
          </div>
          <p className="marketing-page__lead">Choose the right plan for your agency.</p>

          <aside className="pricing-offer-banner">
            <p className="pricing-offer-banner__kicker">Diwali Special Offer</p>
            <p className="pricing-offer-banner__title">₹0 Registration Fee</p>
            <p className="pricing-offer-banner__text">
              Company registration is free. Pay ₹100 to activate your first user; extra
              users are ₹100 each when you activate them.
            </p>
            <Link to={`/register-company?plan=${selected.id}`} className="primary-page-btn">
              Register for Free
            </Link>
          </aside>
        </header>

        <DiwaliOfferOverlay onExplore={scrollToPlans} />

      <div className="pricing-grid" id="pricing-plans" role="list">
        {SSDI_PLANS.map((plan) => {
          const isSelected = selectedId === plan.id;

          return (
            <article
              key={plan.id}
              role="listitem"
              className={`pricing-card${plan.popular ? " is-featured" : ""}${
                isSelected ? " is-selected" : ""
              }`}
              data-accent={plan.accent}
              tabIndex={0}
              onClick={() => setSelectedId(plan.id)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  setSelectedId(plan.id);
                }
              }}
            >
              <div className="pricing-card__badges">
                {plan.popular ? (
                  <span className="pricing-badge pricing-badge--popular">Popular</span>
                ) : null}
                {isSelected ? (
                  <span className="pricing-badge pricing-badge--pick">Selected</span>
                ) : null}
              </div>

              <h2 className="pricing-card__name">{plan.name}</h2>
              <p className="pricing-card__price">
                <span>{plan.priceLabel}</span>
                <small> / {plan.priceUnit}</small>
              </p>
              <p className="pricing-card__note">{plan.billingNote}</p>

              <ul className="pricing-card__features">
                {plan.features.map((feature) => (
                  <li key={feature}>
                    <FiCheck aria-hidden />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              <button
                type="button"
                className="pricing-card__cta"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedId(plan.id);
                }}
              >
                {isSelected ? `Continue with ${plan.name}` : `Select ${plan.name}`}
              </button>
            </article>
          );
        })}
      </div>

      <section className="pricing-compare" aria-labelledby="pricing-compare-title">
        <h2 id="pricing-compare-title">Compare plans</h2>
        <p className="pricing-compare__lead">Tap a column header to select that plan.</p>
        <div className="pricing-compare__scroll">
          <table className="pricing-compare__table">
            <thead>
              <tr>
                <th scope="col">Feature</th>
                {SSDI_PLANS.map((plan) => (
                  <th
                    key={plan.id}
                    scope="col"
                    className={selectedId === plan.id ? "is-col-highlight" : ""}
                  >
                    <button type="button" onClick={() => setSelectedId(plan.id)}>
                      {plan.name}
                    </button>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {PLAN_COMPARISON_ROWS.map((row) => (
                <tr key={row.label}>
                  <th scope="row">{row.label}</th>
                  {SSDI_PLANS.map((plan) => (
                    <td
                      key={plan.id}
                      className={selectedId === plan.id ? "is-col-highlight" : ""}
                    >
                      {row[plan.id]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <div className="pricing-cta-bar">
        <div>
          <p className="pricing-cta-bar__label">Selected</p>
          <p className="pricing-cta-bar__choice">
            <strong>Register For Free</strong>
          </p>
        </div>
        <div className="marketing-page__actions pricing-cta-bar__actions">
          <Link to={`/register-company?plan=${selected.id}`} className="primary-page-btn">
            Register for Free
          </Link>
          <Link to="/" className="secondary-page-btn">
            ← Back to Login
          </Link>
        </div>
      </div>
      </div>
    </MarketingPageLayout>
  );
}
